/* globals dataLayer, angular */
(function (window, angular, undefined) {
    angular.module('formApp')
        .component('wishToDonate', {
            templateUrl: 'components/wish-to-donate/templates/wish-to-donate.html',
            bindings: {
                formData: '<',
                eQuote: '<',
                eCoverNote: '<',
                freeCoverExpired: '<',
                c4lTitle: '@',
                essentialTitle: '@',
                rabbitTitle: '@'
            },
            controller: ['dataUtils', '$filter', 'FormService', 'LoadingInterceptor', '$http', '$rootScope', 'formData', 'scrollToPoint',function (dataUtils, $filter,formService, loadingInterceptor, $http,$rootScope, formData,scrollToPoint) {

                var ctrl = this;
                ctrl.loading = false;
                if (formData.charitableDonation && formData.charitableDonation.wishesToDonate === 'Y') {
                    ctrl.charityDonation = true;
                } else {
                    ctrl.charityDonation = false;
                }
                formService.getRunningTotals().then(
                    function(response) {
                       ctrl.formData.runningTotals = response.data;
                        if(ctrl.formData.runningTotals.charitableDonation){
                            ctrl.charityDonation = true;
                            ctrl.aria = 'Remove charity donation button';

                        }
                        else{
                            ctrl.charityDonation = false;
                            ctrl.aria = 'Add charity donation';
                        }
                        ctrl.loading = false;
                    }
                );
                ctrl.openCModal = function(){
                    console.log('opne CP');
                    $rootScope.charityModalPop = true;
                    $rootScope.$broadcast('charityInfo');
                    scrollToPoint.scrollTo('topOfTheApp', 20, 'id');
                };

                ctrl.postCharitableDonation = function(cd) {
                    var cDonation = cd ? 'Y' : 'N';
                    formData.charitableDonation = {wishesToDonate: cDonation};
                    ctrl.loading = true;
                    formService.postCharitableDonation({wishesToDonate: cDonation}).then(function success() {
                        formService.getRunningTotals().then(
                            function(response) {
                                ctrl.formData.runningTotals = response.data;
                                if(ctrl.formData.runningTotals.charitableDonation){
                                    ctrl.charityDonation = true;
                                    ctrl.aria = 'Remove charity donation button';
        
                                }
                                else{
                                    ctrl.charityDonation = false;
                                    ctrl.aria = 'Add charity donation';
                                }
                            }
                        );
                        ctrl.loading = false;
                    }, function failure(e) {
                       // errorHandler.reportErrors(e,'redirect','tech');
                    });
                };


            }]
        });
})(window, window.angular);